export default __webpack_public_path__ + "static/media/autostrada.375ed8bf.svg";